import { render } from "./ShippingRatesTable.vue?vue&type=template&id=521a795e"
import script from "./ShippingRatesTable.vue?vue&type=script&lang=ts"
export * from "./ShippingRatesTable.vue?vue&type=script&lang=ts"

import "./ShippingRatesTable.vue?vue&type=style&index=0&id=521a795e&lang=scss"
script.render = render

export default script